import {Component} from 'react';
import * as Sentry from '@sentry/react';

// Error boundary local del panel de detalle: si un renderer lanza con un detail
// inesperado, se pinta el fallback (render genérico) en vez de tumbar la fila o la
// pantalla. Segunda línea de defensa — la primera son las guards canRender del registry.
export class DetailRenderGuard extends Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false};
    }

    static getDerivedStateFromError() {
        return {hasError: true};
    }

    componentDidCatch(error, errorInfo) {
        Sentry.captureException(error, {extra: {componentStack: errorInfo.componentStack, scope: 'activity_log_detail'}});
    }

    render() {
        if (this.state.hasError) return this.props.fallback || null;
        return this.props.children;
    }
}
